export const clientId = '2'
export const clientSecret = 'Q0eIAHnXGtnjUWbHLI3Y3PTFsbHMdVfGEZledcw'



// WEBPACK FOOTER //
// ./src/env.js